export const formatFrameRate = (frameRate: readonly [number, number]): string => {
  if (frameRate[0] % frameRate[1] === 0) {
    return `${frameRate[0] / frameRate[1]}p`
  }

  return `${(frameRate[0] / frameRate[1]).toFixed(2)}p`
}
